// @flow
import styled from "styled-components";

export const FlexDiv = styled.div`
    display: flex
`;